var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoZgOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ZoomGroomLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 232.53",
    style: {
      enableBackground: "new 0 0 390 232.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.54,149.12c-2.09,4.54-10.21,22.4-10.21,27.55c0,7.27,12.53,6.96,16.01,6.96 c40.61,0,27.38-39.96,45.02-39.96c11.6,0,16.71,9.08,16.71,23.31c0,32.7-15.32,57.22-23.44,57.22c-1.16,0-5.57-0.61-10.44-1.51 c-4.87-0.61-10.21-1.21-13.46-1.21H23.8c-7.89,0-16.48,2.72-16.48-11.5c0-5.75,2.78-10.6,4.87-15.14L70.67,65.25 c1.16-2.42,4.18-8.17,4.18-11.5c0-7.87-9.51-8.78-15.32-8.78c-29.24,0-22.05,40.87-38.52,40.87C11.5,85.84,5,71.61,5,60.1 c0-23.01,16.01-54.5,21.58-54.5c1.16,0,2.78,0.91,7.43,2.12c4.87,0.91,13.23,1.51,27.61,1.51c9.98,0,27.85-0.3,45.02-1.82 C123.58,6.21,139.59,5,145.16,5C151.89,5,157,10.45,157,19.83c0,5.45-3.71,12.72-5.57,17.26L101.54,149.12z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-675, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M947.35,181.51c8.12,0,14.16-7.87,14.16-18.77c0-25.13-24.37-0.61-24.37-28.46 c0-22.1,35.04-23.62,46.88-23.62c43.63,0,46.18,16.05,46.18,24.83c0,7.87-5.11,13.32-10.67,14.53c-6.03,0.91-6.5,2.42-8.12,10.29 c-9.05,44.2-41.77,65.4-74.72,65.4c-49.19,0-92.13-44.51-92.13-111.42c0-63.88,41.54-109.3,91.2-109.3 c20.42,0,31.56,8.17,37.59,8.17c4.18,0,10.21-4.54,14.39-4.54c14.39,0,22.97,30.88,22.97,46.32c0,14.83-5.8,29.97-18.33,29.97 c-22.97,0-22.97-42.08-54.53-42.08c-20.19,0-33.18,21.8-33.18,53.89C904.65,159.11,932.49,181.51,947.35,181.51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZgOnly);
export default __webpack_public_path__ + "static/media/logo_ZG_only.c02424f4bcea65c277821102d4a0aff2.svg";
export { ForwardRef as ReactComponent };